import { ActionIcon, Group, Tooltip, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export function ColorSchemeToggle() {
    const { t } = useTranslation();
    const { colorScheme, setColorScheme } = useMantineColorScheme();

    const isDark = colorScheme === 'dark';

    return (
        <Group gap={4}>
            <Tooltip label={isDark ? t('theme.lightMode') : t('theme.darkMode')}>
                <ActionIcon
                    variant="default"
                    size="lg"
                    radius="md"
                    aria-label={t('theme.toggleColorScheme')}
                    onClick={() => setColorScheme(isDark ? 'light' : 'dark')}
                >
                    {isDark ? <IconSun size={18} stroke={1.5} /> : <IconMoon size={18} stroke={1.5} />}
                </ActionIcon>
            </Tooltip>
        </Group>
    );
}
